var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-select', {
    staticClass: "w-lg-100px",
    attrs: {
      "items": _vm.searchKeys,
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.searchKey,
      callback: function callback($$v) {
        _vm.searchKey = $$v;
      },
      expression: "searchKey"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "",
      "lg": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "w-lg-240px",
    attrs: {
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.searchValue,
      callback: function callback($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "grey",
      "small": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('search', {
          searchKey: _vm.searchKey,
          searchValue: _vm.searchValue
        });
      }
    }
  }, [_vm._v("Search")])], 1)], 1), _c('v-divider', {
    staticClass: "board-divider"
  }), _c('v-row', [_vm._l(_vm.boards, function (board) {
    return [_c('v-col', {
      key: board._id,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('v-card', {
      attrs: {
        "tile": "",
        "flat": ""
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('click', board);
        }
      }
    }, [_c('v-img', {
      attrs: {
        "src": board.thumb
      }
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 1 / 1
      }
    })], 1), _c('v-card-title', {
      staticClass: "ellip"
    }, [_vm._v(_vm._s(board.subject))]), _c('v-card-text', [_vm._v(_vm._s(board.createdAt.toDate()))])], 1)], 1)];
  })], 2), _vm._t("pagination")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }